import { render, staticRenderFns } from "./HolidayCard.vue?vue&type=template&id=2bc1c83a&scoped=true&"
import script from "./HolidayCard.vue?vue&type=script&lang=js&"
export * from "./HolidayCard.vue?vue&type=script&lang=js&"
import style0 from "./HolidayCard.vue?vue&type=style&index=0&id=2bc1c83a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1c83a",
  null
  
)

export default component.exports